import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=e2a8bfc2&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=e2a8bfc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a8bfc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2a8bfc2')) {
      api.createRecord('e2a8bfc2', component.options)
    } else {
      api.reload('e2a8bfc2', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=e2a8bfc2&scoped=true&", function () {
      api.rerender('e2a8bfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navMenu/menuManager/components/addDynamic.vue"
export default component.exports